import 'jquery/dist/jquery.min.js';

import ReactComponentMounter from '../utils/react-component-mounter';
import Microfrontend from '../apps/Microfrontend';

ReactComponentMounter.register({
  Microfrontend
});

export { Microfrontend, ReactComponentMounter };
